import { render, staticRenderFns } from "./BulletinBoard.vue?vue&type=template&id=215eb998&scoped=true&"
import script from "./BulletinBoard.vue?vue&type=script&lang=js&"
export * from "./BulletinBoard.vue?vue&type=script&lang=js&"
import style1 from "./BulletinBoard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215eb998",
  null
  
)

export default component.exports